import React from 'react'
import { Tooltip } from 'antd'
import { useLingui } from '@lingui/react/macro'
import {
  LIBRARY_CATEGORIES,
  getLibraryCategoryByMusicType,
} from '@loc/server/utils/music'

import { useInWhichPage } from '@/hooks/useInWhichPage'

export interface MusicTitleProps {
  id?: string
  children?: string | null
  musicType?: string | null
  error?: boolean
  inGlobalPlayer?: boolean
  className?: string
}

const MusicTitle: React.FC<MusicTitleProps> = (props) => {
  const { id, error, children, inGlobalPlayer, className, musicType } = props

  const { inLibraryPage } = useInWhichPage()
  const titleCoreCls = cls`
    text-f-text-secondary w-fit min-w-0 ${inLibraryPage && !inGlobalPlayer ? 'line-clamp-1 md:line-clamp-2' : 'block max-w-[220px] truncate lg:max-w-[300px] 2xl:max-w-[500px]'}
    text-sm font-semibold ${className}
  `
  const { t } = useLingui()
  const internalChildren = children || t`Untitle`
  const { inDetailPage } = useInWhichPage()
  const globalAudioPlayer = useGlobalAudioPlayer()
  const tagLabel = useMemo(() => {
    switch (getLibraryCategoryByMusicType(musicType)) {
      case LIBRARY_CATEGORIES.AiMusic:
        return t`AI Music`
      case LIBRARY_CATEGORIES.AiCover:
        return t`AI Cover`
      case LIBRARY_CATEGORIES.TextToSpeech:
        return t`Text to Speech`
      case LIBRARY_CATEGORIES.All:
      default:
        return null
    }
  }, [musicType, t])

  return (
    <span className='text-f-text-secondary mb-1 inline-flex min-w-0 flex-wrap items-center gap-1.5 text-[14px]'>
      {error ? (
        <span className={titleCoreCls}>{internalChildren}</span>
      ) : (
        <Tooltip title={internalChildren} placement='topLeft'>
          <span
            className={cls`${titleCoreCls} ${!inDetailPage ? 'hover:text-f-text-secondary cursor-pointer hover:underline' : ''}`}
            onClick={() => {
              if (!inDetailPage) {
                globalAudioPlayer.toggleShowDetail(true)
              }
            }}
          >
            {internalChildren}
          </span>
        </Tooltip>
      )}

      {tagLabel ? (
        <span
          className={cls`
            bg-f-bg-elevated text-f-text-quaternary inline-flex shrink-0 
            items-center rounded px-2 py-0.5 text-xs 
          `}
        >
          {tagLabel}
        </span>
      ) : null}
    </span>
  )
}

export default MusicTitle
